'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.uniq = uniq;
exports.isEmpty = isEmpty;
exports.toArray = toArray;
// Contains common functions to work with collections

/**
 * 
 * Removes duplicate items from an array.
 */
function uniq(arr) {
    return Array.from(new Set(arr));
}

/**
 * 
 * Determines if the given collection has no elements.
 *
 * If the object is not iterable, return it's falsiness value.
 */
function isEmpty(coll) {
    if ((typeof coll === 'undefined' ? 'undefined' : _typeof(coll)) !== 'object') {
        // If not an object or an array, return it's falsiness value.
        // Note: arrays are objects, so they won't enter here.
        return !coll;
    }
    // Test arrays and objects for number of items / keys
    return Object.keys(coll).length === 0;
}

/**
 * 
 * Converts an object to an array
 */
function toArray(obj) {
    return Object.keys(obj).map(function (k) {
        return obj[k];
    });
}